module.exports = __webpack_public_path__ + "static/media/説明画像.113c60ce.png";